module.exports = __webpack_public_path__ + "img/heart_small.1f61f337.svg";